import script from "./FctUtils.vue?vue&type=script&lang=js"
export * from "./FctUtils.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__